module.exports = __webpack_public_path__ + "static/media/saint-laurent.b58978d6.jpg";